import { FieldTypeOption } from "@kaltura/mediaspace-shared-types";
import { FormValues } from "@kaltura/mediaspace-shared-ui/form";
import { Template } from "@kaltura/mediaspace-shared-ui/controlled-form";

/**
 * Form values for creating a new room
 */
export interface CreateRoomFormValues extends FormValues {
    /**
     * The selected room mode/template ID
     */
    roomMode: string;

    /**
     * Room availability option (always open or scheduled)
     */
    roomSchedulingType: ScheduleOptions;
}

/**
 * Room availability options
 */
export enum ScheduleOptions {
    ALWAYS = "always",
    SCHEDULED = "scheduled",
}

export type FormOptions = {
    templates: Template[];
    timezones: FieldTypeOption[];
};
